import { Base } from "./base";
import { Warehouse } from "./warehouse";
import { MapCell } from "./warehouse.mapcell";
import { WarehouseSection } from "./warehouse.section";

export enum AxisConfigType {
  NUMERIC = "numeric",
  ALPHABETICAL = "alphabetical",
}

export enum AxisConfigOrdination {
  ASC = "asc",
  DESC = "desc",
}

export enum AxisName {
  ROW = "row",
  COLUMN = "column",
  LEVEL = "level",
}

export type AxisConfig = {
  type: AxisConfigType;
  ordination: AxisConfigOrdination;
  size: number;
  initial?: number;
  prefix?: string;
  suffix?: string;
};

export interface WarehouseMap extends Base {
  name: string;
  description?: string;
  configColumnId?: number;
  configColumn?: AxisConfig;
  configRowId?: number;
  configRow?: AxisConfig;
  configLevelId?: number;
  configLevel?: AxisConfig;
  sectionId?: number;
  section?: WarehouseSection;
  warehouseId?: number;
  warehouse?: Warehouse;
  isActive: boolean;
  mapCells?: MapCell[];
}
